<template>
  <div class="main">
    <div class="header">
      <Header></Header>
    </div>
    <!-- <div class="content" @scroll="handleScroll"> -->
      <div class="content" @scroll="handleScroll">
      <router-view></router-view>
    </div>
    <right-tool></right-tool>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import RightTool from "@/components/RightTool";
import { mapState, mapMutations } from "vuex";
export default {
  components: {
    Header,
    RightTool,
  },

  methods: {
    ...mapMutations(["scrollTopChange"]),
    handleScroll(event) {
      this.scrollTopChange(event.target.scrollTop);
    },
  },
};
</script>
<style lang="scss" scoped >
.main {
  width: 100%;
  height: 100%;
  position: relative;
  .header {
    width: 100%;
    height: 72px;
    position: fixed;
    z-index: 999;
  }
  .content {
    width: 100%;
    height: calc(100%);
    // overflow-y: scroll;
    height: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/main.vue